import { cn } from '@/helpers/classnames';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
export interface FormElementProps {
  input: React.ReactNode;
  label?: React.ReactNode;
  labelHint?: React.ReactNode;
  button?: React.ReactNode;
  className?: string;
  visible?: boolean;
  required?: boolean;
  id?: string;
}

export const FormElement = ({
  input,
  label,
  labelHint,
  button,
  className,
  visible = true,
  required = false,
  id,
}: FormElementProps) => {
  const elementContent = useMemo(() => {
    if (button) {
      return <div className="w-full min-w-0 flex-1">{button}</div>;
    }
    if (input) {
      return <div className="w-full min-w-0 flex-1">{input}</div>;
    }

    return (
      <span className="italic text-gray-600">
        <FormattedMessage
          id="formElement.noValue"
          defaultMessage="Inget värde"
        />
      </span>
    );
  }, [button, input]);

  if (!visible) return;

  const labelElement = label && (
    <label
      htmlFor={id}
      className={cn('text-text-700', !labelHint && 'sm:w-1/3')}
    >
      {label}{' '}
      {required && (
        <>
          <span className="ml-1" aria-hidden="true">
            *
          </span>
          <span className="sr-only">
            <FormattedMessage
              id="formElement.requiredFieldHint"
              defaultMessage="(obligatoriskt fält)"
            />
          </span>
        </>
      )}
    </label>
  );

  return (
    <div
      className={cn(
        'flex w-full flex-col items-start gap-2 sm:flex-row',
        className,
      )}
    >
      {labelHint ? (
        <div className="flex items-center gap-1 sm:w-1/3">
          {labelElement}
          {labelHint}
        </div>
      ) : (
        labelElement
      )}
      {elementContent}
    </div>
  );
};
